const t = (c, o) => (c || o) ?? "";
export {
  t as c
};
//# sourceMappingURL=useSelectLabel.D5gieJRx.js.map
